import {
  GET_PAYMENTCONFIG_LOADING,
  GET_PAYMENTCONFIG_SUCCESS,
  GET_PAYMENTCONFIG_FAILED,
  GET_PAYMENTCONFIG_REMOVE,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  merchantsConfig: null,
  status: null
};

export const getMerchantPaymentConfigReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any, status: any }
) => {

  switch (action.type) {
    case GET_PAYMENTCONFIG_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_PAYMENTCONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        merchantsConfig: action.payload,
        error: null,
        status: action.status
      };
    case GET_PAYMENTCONFIG_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        status: action.status,
      };
    case GET_PAYMENTCONFIG_REMOVE:
      return initialState;

    default:
      return state;
  }
};
